/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * Arbi API
 * OpenAPI spec version: 1.0.0
 */
import type { ScheduleItemInputs } from './scheduleItemInputs';
import type { ScheduleOverride } from './scheduleOverride';

export interface ScheduleItem {
  calendar_event_id: string;
  occurrence_start: string;
  title: string | null;
  decision: string;
  reason: string | null;
  inputs: ScheduleItemInputs;
  conversation_id: string | null;
  override: ScheduleOverride | null;
  attendees_count: number | null;
  can_override: boolean;
  state: string | null;
  meeting_url?: string | null;
}
